<template>
  <b-card>
    <!-- eslint-disable-next-line vue/no-v-html -->
    <div v-html="$t('companies.commissions_alert')" />
  </b-card>
</template>

<script>
export default {
  name: 'CommissionsNotice',
}
</script>
